import { Injectable } from '@angular/core';
import { AssetLoader } from '../common/ScriptLoader';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ScriptService {
	public assetsUrl;
	public imgUrl;
	public mediaServerUrl;
	// 防止同時間載入兩次 script
	public waitingList: any[] = [];
	public loadedScript: any[] = [];

	private assetsLoaded = false;

	constructor() {
		this.initAssetUrl();
	}

	initAssetUrl() {
		let app_base_href: string = document.querySelector("base").getAttribute("href");

		this.assetsUrl = app_base_href + 'assets/';
		if (location.port != '') {
			// this.assetsUrl = '//dev.openknowledge.hk/RainbowOne/webapp/2.8/roWeb/assets/';
		}
		this.imgUrl = this.assetsUrl + 'img/';
		this.mediaServerUrl = environment.blobStorage;
	}

	load(filename, options: any = {}) {
		filename = filename.replace('[blob]/', environment.blobStorage);
		filename = filename.replace('[blob]', environment.blobStorage);

		// 1. 如果强制重载，先清掉 loadedScript 记录
		if (options.forceReload) {
			this.loadedScript = this.loadedScript.filter(x => x !== filename);
		}

		if (this.loadedScript.includes(filename)) {
			return Promise.resolve(null);
		}

		// 2. 加时间戳，强制浏览器重新下载，不走缓存
		let url: string = filename.includes("//")
			? filename
			: this.assetsUrl + filename;
		if (options.forceReload) {
			url += (url.includes('?') ? '&' : '?') + 't=' + Date.now();
		}

		return new Promise((resolve, reject) => {
			// 3. 先删页面上所有同名 script
			let elems = document.querySelectorAll(`script[src^="${filename}"]`);
			elems.forEach(el => el.remove());

			let scriptElement = document.createElement('script');
			scriptElement.src = url;
			scriptElement.type = 'text/javascript'; // 必须是普通 script，不能是 module

			scriptElement.onload = () => {
				// 4. 给 UMD 一点时间挂载，再 resolve
				setTimeout(() => {
					scriptElement.setAttribute('ready', 'true');
					this.loadedScript.push(filename);

					// 通知 waitingList
					this.waitingList = this.waitingList.filter(e => {
						if (e.url === url) {
							e.resolve(null);
							return false;
						}
						return true;
					});

					resolve(null);
				}, options.delayResolve || 300); // 300ms 足够 UMD 挂载
			};

			scriptElement.onerror = (err) => {
				reject({ msg: 'load error ' + filename, error: err });
			};

			document.body.appendChild(scriptElement);

			let timeout = options.timeout || 10000;
			setTimeout(() => {
				reject({ msg: 'timeout load ' + filename });
				this.waitingList = this.waitingList.filter(e => {
					if (e.url === url) {
						e.reject({ msg: 'timeout load ' + filename });
						return false;
					}
					return true;
				});
			}, timeout);
		});
	}

	/*protected checkUploaded(filename){
		let ele =  document.querySelector('script[src="' + filename +'"]');
		return !!ele;
	}*/

	// load the color picker once
	public loadColorisAssets(basePath: string): Promise<void> {
		if (this.assetsLoaded) {
			return Promise.resolve();
		}
		return AssetLoader.load([
			{ type: 'css', url: basePath + 'coloris/coloris.css' },
			{ type: 'js', url: basePath + 'coloris/coloris.js', name: 'Coloris' },
		]).then(() => {
			this.assetsLoaded = true;
		});
	}
}
